import type {ImageProps} from 'next/image';
import Image from 'next/image';
import type {FC} from 'react';

type Props = ImageProps;

const NavbarLogo: FC<Props> = props => {
  return <Image {...props} />;
};

export default NavbarLogo;
export type {Props as NavbarLogoProps};
